import { render, staticRenderFns } from "./guestInfoPC.vue?vue&type=template&id=bd347274&scoped=true"
import script from "./guestInfoPC.vue?vue&type=script&lang=js"
export * from "./guestInfoPC.vue?vue&type=script&lang=js"
import style0 from "./guestInfoPC.vue?vue&type=style&index=0&id=bd347274&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd347274",
  null
  
)

export default component.exports